var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25995 10.1472C3.9849 12.2527 3.821 14.3713 3.76895 16.4942C6.64774 17.6967 9.40411 19.1735 12 20.9042C14.5961 19.1735 17.3528 17.6967 20.232 16.4942C20.1799 14.3713 20.016 12.2527 19.741 10.1472M19.741 10.1472C20.616 9.85316 21.503 9.58116 22.399 9.33316C19.1355 7.04541 15.6519 5.08905 12 3.49316C8.34794 5.08938 4.86435 7.04608 1.60095 9.33416C2.49423 9.58076 3.38057 9.85186 4.25895 10.1472C6.92761 11.0443 9.51689 12.1622 12 13.4892C14.4827 12.1622 17.0726 11.0444 19.741 10.1472ZM6.74995 15.0002C6.94886 15.0002 7.13963 14.9211 7.28028 14.7805C7.42093 14.6398 7.49995 14.4491 7.49995 14.2502C7.49995 14.0513 7.42093 13.8605 7.28028 13.7198C7.13963 13.5792 6.94886 13.5002 6.74995 13.5002C6.55104 13.5002 6.36027 13.5792 6.21962 13.7198C6.07897 13.8605 5.99995 14.0513 5.99995 14.2502C5.99995 14.4491 6.07897 14.6398 6.21962 14.7805C6.36027 14.9211 6.55104 15.0002 6.74995 15.0002ZM6.74995 15.0002V11.3252C8.44669 10.2705 10.1992 9.30843 12 8.44316M4.99295 19.9932C5.55092 19.4366 5.99339 18.7752 6.29492 18.047C6.59644 17.3189 6.75108 16.5383 6.74995 15.7502V14.2502",
    stroke: "#1E073A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.935843119802fd50343100d90996c27c.svg";
export { ForwardRef as ReactComponent };